module.exports = require("@swa-ui/core/src/Button/Button.module.scss");